import React, { useEffect, useState } from 'react'
import { find } from 'ramda'
import { Autosuggest } from '@/components/Autosuggest'
import * as console from '../../lib/console'
import callAPI from '../../modules/api/call'

type Props = {
  label: string
  name: string
  kind: string
  value: string
  onChange: (props: { name: string; value: string }) => void
  allowFreeText?: boolean
}

export const JobTitlePicker = ({
  label,
  name,
  kind,
  value,
  allowFreeText,
  onChange,
}: Props) => {
  const [term, setTerm] = useState(value)
  const [isLoading, setIsLoading] = useState(false)
  const [suggestions, setSuggestions] = useState([])

  useEffect(() => {
    setIsLoading(true)

    const t = term

    callAPI({
      url: `/api/job-titles?q=${encodeURIComponent(
        term
      )}&kind=${encodeURIComponent(kind)}&per_page=100`,
      debounce: true,
      id: '/api/job-titles',
    }).then(
      ({ payload }) => {
        setIsLoading(false)
        if (term === t) {
          setSuggestions(payload.results)
        }
      },
      error => {
        setIsLoading(false)
        if (error && !error.cancelled) {
          console.error(error)
        }
      }
    )
  }, [term])

  const handleChangeEvent = (e, { newValue }) => {
    const lower = newValue?.toLowerCase()
    const suggestion = find(
      x => x.job_title.toLowerCase() === lower,
      suggestions
    )
    if (suggestion) {
      onChange({ name, value: suggestion.job_title })
      if (typeof suggestion.seniority === 'string') {
        onChange({ name: 'seniority', value: suggestion.seniority })
      } else {
        onChange({ name: 'seniority', value: '' })
      }
    } else {
      if (allowFreeText) {
        onChange({ name, value: newValue })
      }
      onChange({ name: 'seniority', value: '' })
    }
  }

  const handleSuggestion = suggestion => {
    setTerm(suggestion?.job_title ?? '')
    onChange({ name, value: suggestion?.job_title })
    if (typeof suggestion?.seniority === 'string') {
      onChange({ name: 'seniority', value: suggestion.seniority })
    }
  }

  const handleSuggestionsUpdateRequested = value => {
    setTerm(value ?? '')
  }

  const getSuggestionValue = (suggestion: any): string => {
    return suggestion?.job_title ?? ''
  }

  const renderSuggestion = (suggestion: any): React.ReactElement => {
    return (
      <div>
        <div>{suggestion.job_title}</div>
      </div>
    )
  }

  return (
    <Autosuggest
      label={label}
      initialSelectedItem={undefined}
      suggestions={suggestions}
      onSuggestionsFetchRequested={handleSuggestionsUpdateRequested}
      onSuggestionSelected={handleSuggestion}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
    />
  )
}

export default JobTitlePicker
